import * as Yup from 'yup';

import { alphabets } from '@utils/regex';
import YupUtil from '@utils/YupUtil';

export const LoginSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
});

export const ForgotPasswordSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Email is required'),
});

export const ResetPasswordSchema = Yup.object().shape({
    password: YupUtil.getPasswordScheme('password', 'Password', true),
    confirmPassword: YupUtil.getConfirmPasswordScheme(
        'confirmPassword',
        'Confirm Password',
        true,
        'password'
    ),
});

export const MenteeRegisterSchema = Yup.object().shape({
    name: YupUtil.getStringTrimmedScheme('fullName', 'Fullname', true, 3, 25, alphabets),
    email: YupUtil.getEmailScheme('email', 'Email', true),
    phone: Yup.string()
        .required('Phone number is required')
        // eslint-disable-next-line func-names
        .test('phone-format', 'Invalid phone number', function (value) {
            if (!value || !this.parent.countryCode) return false;
            return value.length >= 8 && value.length <= 15;
        }),
    password: YupUtil.getPasswordScheme('password', 'Password', true),
    domainId: YupUtil.getStringDropdownScheme('domain', 'Domain', true),
});

const CVSchema = Yup.object().shape({
    cv: YupUtil.getStringTrimmedScheme('cv', 'CV', true, 3, 100),
});

export const MentorRegisterSchema = MenteeRegisterSchema.concat(CVSchema);
